<template>
  <div id="app">
    <div class="AppTemplate" v-if="isClient">
      <TheHeader v-if="isClient" />
      <router-view />
    </div>
    <div class="AdminTemplate" v-if="isAdmin">
      <div class="LeftSide" id="sidebar">
        <TheSidebar v-if="isAdmin" />
      </div>
      <div class="RightSideHome">
        <TheHeader id="HomeStyle" />
        <router-view />
      </div>
    </div>
    <div v-if="!isAdmin && !isClient">
      <TheHeader />
      <router-view />
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import TheSidebar from "@/components/TheSidebar.vue";
import Auth from "@/services/auth.service";
import { mapState } from "vuex";
const authService = new Auth();

export default {
  components: {
    TheHeader,
    TheSidebar,
  },
  mounted () {
    window.onload = () => {
      document.addEventListener("touchstart", event => {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });

      let lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        event => {
          const now = new Date().getTime();
          if (now - lastTouchEnd <= 500) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    };
  },
  data () {
    return {};
  },
  computed: {
    ...mapState({
      default: state => state.ui.default,
    }),
    currentUser () {
      return this.$store.state.user;
    },
    isClient () {
      return (
        (this.currentUser && Auth.isClient(this.currentUser.role)) ||
        this.currentUser === null
      );
    },
    isAdmin () {
      return this.currentUser && Auth.isAdmin(this.currentUser.role);
    },
  },
  watch: {
    "$route.name" () {
      this.checkAuthority();
    },
  },
  methods: {
    async checkAuthority () {
      const { $router } = this;
      const userResult = await authService.getCurrentUser().catch(e => {
        return { error: true, msg: e };
      });
      if (userResult.error) {
        return $router.push("/sign-in");
      } else if (!userResult.signInUserSession) {
        return $router.push("/sign-in");
      }
    },
    onClickCreateOrder () {
      const { $router } = this;
      $router.push("/orders/create/step1");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

#app > * {
  height: 100%;
  touch-action: manipulation;
}
.AdminTemplate {
  display: flex;
}
.LeftSide {
  height: 100%;
  width: 165px;
  position: fixed;
  z-index: 100;
}
.RightSide {
  width: 100%;
  box-sizing: border-box;
}
.RightSideHome {
  width: 100%;
  padding-left: 165px;
  box-sizing: border-box;
}
</style>

<style lang="scss">
@import "~@/assets/styles/global.scss";

html, body {
  height: 100%;
  margin: 0;
  font-family: 'Noto Sans JP', -apple-system, 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', meiryo, Verdana, 'lr oSVbN';
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text-base;
  height: 100%;
}
</style>
